import * as React from 'react';
import { SVGProps } from 'react';

const IconLentaStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 10a1 1 0 0 1-1-1V3a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h9v-1Zm-1.732 0H2V3h7v6c0 .364.097.706.268 1Z"
    />
    <path d="M3 4h2v2H3V4ZM6 7h2v2H6V7Z" />
  </svg>
);
export default IconLentaStrokedSizeXs;
